module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newDy"
  }, [_c('div', {
    staticClass: "nd-topitem"
  }, [_c('div', {
    staticClass: "nd-screenTop"
  }, [_c('div', {
    staticClass: "topcenter"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_c('el-button', {
    staticClass: "nd-selectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('新闻动态')
      }
    }
  }, [_vm._v("新闻动态")]), _vm._v(" "), _c('el-button', {
    staticClass: "nd-noSelectBtn",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('联系我们')
      }
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('el-button', {
    staticClass: "nd-noSelectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('产品介绍')
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('el-button', {
    staticClass: "nd-noSelectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('首页')
      }
    }
  }, [_vm._v("首页")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "newdetial-center clearfix"
  }, [_c('div', {
    staticClass: "newdetial-center-top clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "newdetial-center-top-right clearfix",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("\n            返回上一层 →\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "newdetial-center-title"
  }, [_vm._v("\n         智慧潍坊斩获两项国际殊荣\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "newdetial-center-titleLine"
  }), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "screen-6",
    staticStyle: {
      "height": "300px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "page-bottom clearfix"
  }, [_c('div', {
    staticClass: "page-content-container clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "page-bottom-right clearfix"
  }, [_c('div', {
    staticClass: "page-bottom-right-content"
  }, [_c('div', {
    staticClass: "page-bottom-content-list"
  }, [_c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('首页')
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('产品介绍')
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('联系我们')
      }
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('新闻动态')
      }
    }
  }, [_vm._v("新闻动态")]), _vm._v(">\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "page-bottom-hor-split"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _vm._m(8)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topImage"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "src": require("@/assets/mainlogo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topRight1"
  }, [_c('div', {
    staticClass: "topRight1T"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("业务咨询")])]), _vm._v(" "), _c('div', {
    staticClass: "topRight1B"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("0536-8812347")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "float": "right",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("@/assets/topphone.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newdetial-center-top-center clearfix"
  }, [_c('div', {
    staticStyle: {
      "font-size": "40px",
      "margin-top": "26px",
      "color": "white"
    }
  }, [_vm._v("\n              15\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "18px",
      "color": "white"
    }
  }, [_vm._v("\n              2017/10\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newdetial-center-text"
  }, [_c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("10月份，山东省潍坊市的智慧城市建设接连在国际上获得认可。 Valenti手里接过奖杯，潍坊“智慧城市3.0”斩获2017巴塞罗那世界智慧城市博览会Finalist of City Award（智慧城市提名奖）。全球仅五座城市荣获这项殊荣，潍坊是中国唯一获奖城市")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("10月15日，达沃斯世界经济论坛将“物联潍坊”选入4个典型案例之一，成为组委会面向各国推荐的可持续发展、高复制性的智慧城市建设案例。10月25日，巴塞罗那智慧城市博览会组委会宣布，中国潍坊从全球600余个参评城市中脱颖而出，荣获2017“智慧城市奖提名奖”，将与其他5个获奖城市共同角逐“全球智慧城市奖”。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("“连续斩获两项国际殊荣，这是对智慧潍坊建设思路的认同，也是对潍坊物联城市建设模式的认可和肯定。” 潍坊市智慧城市建设办公室主任张宝庆告诉记者，2017年以来，随着“智慧潍坊3.0”概念的提出以及“华为—潍坊”物联网产业联盟落户，“智慧潍坊”建设驶入快车道，基于NB-IOT物联网技术标准的样本城市建设迅速启动；通过应用移动互联、实名认证技术创新打造“智慧城市通行证”，倡导 “无证、无卡、无钱包”的智慧生活联盟，一幅创新型的智慧城市建设图景正在徐徐展开。")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("建设“物联潍坊” 打造产业强市新增长极")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("世界经济论坛宗旨是探讨世界经济领域存在的问题并促进国际经济合作与交流。今年，世界经济论坛启动了一个全新项目——IoT4D（IoT for sustainable Development）评价，旨在鼓励业界、政府通过物联网来实现城市及社区的可持续发展。经世界经济论坛工作组、麻省理工联合对全球640多个案例进行细致检视，根据项目规模、目标受众、实际影响、可规模化等进行评审，最终选定了4个典型案例，“物联潍坊”得分最高，且是唯一以城市身份入选的案例。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("据介绍，2016年6月，NB-IoT成为新一代物联网技术标准后，潍坊在经过广泛调研和对比论证后，认为具有广覆盖、低功耗、海量接入、低成本优势的NB-IoT将成为远距离无线通讯技术中的佼佼者。潍坊市政府旋即与华为公司携手，合作共建“物联潍坊”，包括构建NB-IoT物联城市感知网络，开展智慧河长、智慧农业、智慧路灯、智慧泊车、智慧市政等城市管理、公共服务和数字经济方面的物联网创新应用，建设基于NB-IoT窄带物联技术的物联城市样板。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("潍坊市智慧办负责人告诉记者，“物联潍坊”不只是一个平台，最终它还将渗透城市管理各个方面，将潍坊真正打造成新型智慧创新城市，物联网对经济可持续发展的影响不可估量。依托华为在智慧城市领域拥有2000多个合作伙伴，目前，华为（潍坊）智慧城市物联网产业联盟已经集聚50余家企业，并将力争3-5年时间形成100亿元产业规模的物联网产业，届时，物联网产业将成为潍坊“产业强市”建设的新一个增长极")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("推广“V派”手机应用 打造品质城市新亮点")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("作为入选本届巴塞罗那智慧城市大会的示范城市项目，“V派”是潍坊应用移动互联、实名认证技术创新打造的全新“智慧城市通行证”。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("“V派”以手机APP方式集成居民身份证、医保卡以及银行卡、公交卡、自行车卡、门禁卡、图书借阅卡、旅游一卡通等各类IC卡，实现市民事项办理、交通出行等的手机便利化应用以及购物、消费、充值、医保、水电气暖和行政事业性缴费等的移动支付。据此，潍坊发起“无证、无卡、无钱包”的“三无智慧生活联盟”，让市民畅享“一机在手、通行全城”的智慧城市新生活。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("目前，“V派”已经在潍坊市县两级政务服务中心、阳光大厦、市级综合办公大楼、市中医院、社保联网药店、部分酒店、商超进行试运行，并在部分县市区启动推广。“V派”与潍坊中百集团合作建设的全省首个无人售货超市也行将在谷德广场落成。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("据介绍，2012年，潍坊市被山东省政府确定为全省首批两个智慧城市试点城市之一，针对智慧城市建设普遍存在的“千城一面”的同质化趋向，潍坊市坚持“以人为本，创新驱动”的建设理念，从市民关注的焦点、热点和难点问题中寻找智慧城市建设切入点，努力探索实践以民生服务为特色的智慧城市建设新模式。“如果说‘物联潍坊’着眼于全面提升城市管理和公共服务的实时化、精细化、智能化水平，那么，V派更注重的是市民获得感，让潍坊市民通过手机可轻松体验智慧便捷生活。”市智慧办负责人告诉记者。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("作为新一代城市通行证，“V派”还将在城市管理与服务中创新更多功能，实现市民办事从“最多跑一次”到“零跑腿”的跨越。“有了这个通行证，市民或企业的一些简单事项办理，可以足不出户，只要通过手机发送身份二维码，相关部门据此即可进行身份识别，并完成相关事项办理。”他介绍，“V派”以其“全维度场景覆盖”和“全虚拟化便捷携带”的特点，可完美取代当前各城市的“市民一卡通”，较高的复制性也是问鼎巴塞罗那智慧城市大会的一个重要原因。")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("巩固优势 释放创新发展新活力")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("此前，智慧潍坊3.0建设案例成功入选国家发改委《2017年中国新型智慧城市建设案例白皮书》。潍坊与华为公司联合编制完成《智慧城市设备联接管理公共服务平台技术要求》全国标准，已通过国家信标委立项。此外，“V派”所依据的“知己”身份认证平台，由潍坊市公安局与智慧泰华产业集团股份有限公司创新研发，以公安户籍信息系统为基础，用户通过手机进行多维度验证，即可获取身份证的手机二维码（电子身份证），从而在网络上证明“我就是我”，实现了现实世界与网络世界公民身份的有效统一。该平台是网络身份认证领域的创新，已获山东省公安厅2017科技进步一等奖，并获公安部立项。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("潍坊智慧办负责人告诉记者，近两年来，在市委、市政府的高度重视和大力推动下，潍坊智慧城市建设发展迅速。斩获这两项国际殊荣，标志着潍坊智慧城市建设到了一个新的高度和层次。下一步，市智慧办将进一步加大工作力度，不断巩固潍坊在全国智慧城市产业的地位和优势，吸聚更多智慧城市建设及相关产业的创新企业、科研机构及专家人才入驻潍坊，为现代化产业强市的发展目标注入创新驱动力，为潍坊创新发展持续注入新活力。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-left"
  }, [_c('img', {
    staticClass: "page-bottom-left-logo",
    attrs: {
      "src": require("@/assets/mainlogo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("公司致力于智慧城市便民服务体系建设和运营，以“V派”城市通行证手机APP为载体，依托云计算、物联网、大数据应用和“互联网+”技术，以创建全国智慧城市样板为目标，逐步提升城市公共服务水平和居民生活品质。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_address_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("山东省潍坊市奎文区恒易宝莲金融中心A座1902")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_tel_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("0536-8812347")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_mail_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("icloudpay@icloudpay.net.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-right-code-container"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": require("@/assets/gw_qrcode.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("扫一扫关注我们")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-41f5d72b"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Guanwang/newdetail4.vue
// module id = 289
// module chunks = 1